import React from 'react';
import { navigate } from 'gatsby';
// import { Grid, Icon, Responsive } from 'semantic-ui-react';
// import Img, { FluidObject } from 'gatsby-image';
// import { Global, css } from '@emotion/core';
import styled from '@emotion/styled';
// import Page from '../components/Page';
// import Container from '../components/Container';
// import IndexLayout from '../components/IndexLayout';
// import { colors } from '../styles/variables';
// import SvgScribblesBone1 from '../pages-scripts/landing/scribbles/boneScribbles1';
// import SvgScribblesBone2 from '../pages-scripts/landing/scribbles/boneScribbles2';
// import SvgScribblesBone3 from '../pages-scripts/landing/scribbles/boneScribbles3';
// import SvgScribblesBoneMb from '../pages-scripts/landing/scribbles/boneScribblesMobile';
// import SvgHcds from '../pages-scripts/landing/hcdsSvg';
// import SvgHcdsMobile from '../pages-scripts/landing/hcdsMobileSvg';
import { mod } from '../utils/modulo';
import { requestTimeout } from '../utils/rafTimeout';
// import IndexLayout from '../components/IndexLayout';
// import { getWidth } from '../utils/responsiveWidthGetter';
// import ContactModal from '../components/ContactModal';

const BlankBackground = styled('div')`
  width: 100vw;
  height: 100%;
  position: absolute !important;
  background-color: #ff5208;
  top: 0 !important;
  right: 0 !important;
`;

// const StyledContentHeaders = styled('p')`
//   font-size: 2.1rem;
//   letter-spacing: 0.125rem;
//   line-height: 4rem;
// `;

// const StyledContentLink = styled('a')`
//   color: black !important;
//   text-decoration: none !important;
//   cursor: pointer !important;
// `;

// const StyledImageWrapper = styled('span')`
//   opacity: 0;
//   transition: opacity 0.3s;
// `;

// const StyledIcon = styled(Icon)`
//   font-size: 2.25em;
//   padding-right: 1.6em;

//   &:hover {
//     color: ${colors.brand};
//   }
// `;

// interface ContentPageSection {
//   contentPageSlug: {
//     current: string;
//   };
//   landingPageSectionTitle: string;
//   landingPageSectionImage: {
//     asset: {
//       fluid: FluidObject;
//     };
//   };
// }

// interface StaticLandingQueryProps {
//   sanityPage: {
//     content: ContentPageSection[];
//   };
// }

/* Helper function to swap classes for a target element */
const swapClasses = (targetId: string, targetClass: string, previousJ: number, currentJ: number) => {
  const removedHCDSElement = document.getElementById(`${targetId}-${previousJ}`);
  if (removedHCDSElement) removedHCDSElement.classList.remove(targetClass);

  const addedHCDSElement = document.getElementById(`${targetId}-${currentJ}`);
  if (addedHCDSElement) addedHCDSElement.classList.add(targetClass);
};

let i = 0; // carousel animation index
let j = 0; // hcds text animation index
let carouselHandle: { value: number };
let hcdsHandle: { value: number };

/* We find the previous heading and remove highlighter classes.
Then, we apply the highlighter effect to the new heading and increment counter */
const updateCarouselTransition = () => {
  swapClasses('underline', 'with-toggle', mod(i - 1, 3), i);
  swapClasses('content-image', 'image-opaque', mod(i - 1, 3), i);
  i = mod(i + 1, 3);
  carouselHandle = requestTimeout(updateCarouselTransition, 3000);
};

/* We repeat the same process to transition the HCDS text between different classes */
const updateHCDSTransition = () => {
  swapClasses('scribbles-bone', 'transparent-text', mod(j - 1, 3), j);
  j = mod(j + 1, 3);
  hcdsHandle = requestTimeout(updateHCDSTransition, 1000);
};

/* Clear timeout and swap classes from old to current hovered heading.
Then increment counter */
// const handleMouseOver = (hoveredI: number) => {
//   if (carouselHandle && carouselHandle.value) {
//     clearRequestTimeout(carouselHandle.value);
//     swapClasses('underline', 'with-toggle', mod(i - 1, 3), hoveredI);
//     swapClasses('content-image', 'image-opaque', mod(i - 1, 3), hoveredI);
//     i = mod(hoveredI + 1, 3);
//   }
// };

// const handleMouseOut = () => {
//   carouselHandle = requestTimeout(updateCarouselTransition, 100);
// };

class IndexPage extends React.Component {
  componentDidMount() {
    navigate('https://home.synthesis.partners/');
    if (carouselHandle) cancelAnimationFrame(carouselHandle.value);
    if (hcdsHandle) cancelAnimationFrame(hcdsHandle.value);

    carouselHandle = requestTimeout(updateCarouselTransition, 200);
    hcdsHandle = requestTimeout(updateHCDSTransition, 50);
    // TODO: Remove this abomination when a better solution comes around
    window.addEventListener('resize', () => this.forceUpdate());
  }

  render() {
    return (
      <BlankBackground />
      // <IndexLayout>
      //   <Page>
      //     <Container>
      //       <StaticQuery
      //         query={graphql`
      //           query LandingPageQuery {
      //             sanityPage(title: { eq: "Landing Page" }) {
      //               title
      //               content {
      //                 ... on SanityLandingPageSection {
      //                   contentPageSlug {
      //                     current
      //                   }
      //                   landingPageSectionTitle
      //                   landingPageSectionImage {
      //                     asset {
      //                       fluid {
      //                         ...GatsbySanityImageFluid
      //                       }
      //                     }
      //                   }
      //                 }
      //               }
      //             }
      //           }
      //         `}
      //         render={(data: StaticLandingQueryProps) => (
      //           <Grid>
      //             <Global
      //               styles={css`
      //                 body {
      //                   background-color: ${colors.blush} !important;
      //                 }

      //                 .underline {
      //                   width: calc(100%);
      //                   background-image: url('/website/highlighter.png');
      //                   background-repeat: no-repeat;
      //                   background-size: 0% 60%;
      //                   background-position: 0 1.6rem;
      //                   transition: background-size 0.6s;
      //                 }

      //                 @media (hover: hover) and (pointer: fine) {
      //                   .links:hover .underline {
      //                     background-size: 100% 60%;
      //                   }
      //                 }

      //                 .with-toggle {
      //                   background-size: 100% 60%;
      //                 }

      //                 .image-opaque {
      //                   opacity: 1 !important;
      //                 }

      //                 .transparent-text {
      //                   opacity: 1 !important;
      //                 }

      //                 #mobile-navbar-dropdown {
      //                   background-color: ${colors.blush};
      //                 }

      //                 @media screen and (min-width: 1px) {
      //                   .right-image-column {
      //                     position: absolute;
      //                   }

      //                   .showcase-images {
      //                     margin-top: 5vh !important;
      //                     opacity: 0.4;
      //                   }
      //                 }

      //                 @media screen and (min-width: 768px) {
      //                   .right-image-column {
      //                     position: null;
      //                   }

      //                   .showcase-images {
      //                     margin-top: -15vh !important;
      //                     opacity: 1;
      //                   }
      //                 }
      //               `}
      //             />
      //             <Grid.Row centered style={{ height: '70vh' }} reversed="computer tablet">
      //               <Grid.Column className="right-image-column" computer="6" tablet="8" mobile="16" verticalAlign="middle">
      //                 {data.sanityPage.content.map((c, l) => (
      //                   <StyledImageWrapper id={`content-image-${l}`}>
      //                     <Img
      //                       className="showcase-images"
      //                       fluid={c.landingPageSectionImage.asset.fluid}
      //                       style={{
      //                         position: 'absolute',
      //                         height: '28vh',
      //                         width: '100%',
      //                         zIndex: -i,
      //                         margin: 'auto',
      //                         top: 0,
      //                         bottom: 0,
      //                         left: 0,
      //                         right: 0,
      //                       }}
      //                       imgStyle={{ objectFit: 'contain' }}
      //                     />
      //                   </StyledImageWrapper>
      //                 ))}
      //               </Grid.Column>
      //               <Grid.Column verticalAlign="middle" textAlign="left" tablet="8" computer="8" mobile="16">
      //                 <Responsive maxWidth="991" getWidth={getWidth}>
      //                   <span>
      //                     <svg width="100%" height="35%" viewBox="0 30 650 430">
      //                       <SvgHcdsMobile />
      //                       <SvgScribblesBoneMb />
      //                     </svg>
      //                   </span>
      //                 </Responsive>
      //                 <Responsive minWidth="992" getWidth={getWidth}>
      //                   <svg width="100%" height="23%" viewBox="0 0 950 230">
      //                     <SvgHcds />
      //                     <SvgScribblesBone1 />
      //                     <SvgScribblesBone2 />
      //                     <SvgScribblesBone3 />
      //                   </svg>
      //                 </Responsive>
      //                 <StyledContentHeaders>
      //                   {data.sanityPage.content.map((c, m) => (
      //                     <StyledContentLink
      //                       href={`/content/${c.contentPageSlug.current}`}
      //                       className="links"
      //                       onMouseOver={() => handleMouseOver(m)}
      //                       onMouseOut={() => handleMouseOut()}
      //                     >
      //                       <span className="underline" id={`underline-${m}`}>
      //                         {`TO ${c.landingPageSectionTitle.toLocaleUpperCase()} ${m !== 2 ? '/' : ''} `}
      //                       </span>
      //                     </StyledContentLink>
      //                   ))}
      //                 </StyledContentHeaders>
      //               </Grid.Column>
      //             </Grid.Row>
      //             <Grid.Row centered style={{ height: '4vh' }}>
      //               <Grid.Column textAlign="right" computer="14" mobile="16" verticalAlign="middle">
      //                 <Responsive minWidth={992} getWidth={getWidth} style={{ display: 'inline-block' }}>
      //                   <StyledContentLink
      //                     href="https://www.instagram.com/synthesis.partners/"
      //                     aria-label="Instagram"
      //                     target="_blank"
      //                     rel="noopener"
      //                   >
      //                     <StyledIcon name="instagram" size="big" />
      //                   </StyledContentLink>
      //                   <StyledContentLink
      //                     href="https://www.linkedin.com/company/synthesispartners/"
      //                     aria-label="Linkedin"
      //                     target="_blank"
      //                     rel="noopener"
      //                   >
      //                     <StyledIcon name="linkedin" size="big" />
      //                   </StyledContentLink>
      //                   <StyledContentLink href="https://medium.com/synthesis-partners" aria-label="Medium" target="_blank" rel="noopener">
      //                     <StyledIcon name="medium" size="big" />
      //                   </StyledContentLink>
      //                 </Responsive>
      //                 <ContactModal />
      //               </Grid.Column>
      //             </Grid.Row>
      //           </Grid>
      //         )}
      //       />
      //     </Container>
      //   </Page>
      // </IndexLayout>
    );
  }
}

export default IndexPage;
